import './knkockout_extend/ko-si';
import './css/select2.css';

try {
    var formkoIsInit = false;
    var initFormko = function() {
        if (false === formkoIsInit) {
            formkoIsInit = true;
        }
    };
} catch (error) {
    console.log(error);
}
